import styles from './AvailabilityError.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const AvailabilityError = ({
  heading = null,
  content = null,
  showButton = true,
  onButtonClick = null,
  buttonText = null,
}) => (
  <div className={styles.container} data-purpose="recommender-error">
    <div className={classNames(styles.icon, styles.red)}>
      <FontAwesomeProIcon icon="circle-exclamation" size="lg" />
    </div>
    <Heading align="center" as="p" size="h5">
      {heading}
    </Heading>
    <Content align="center" size="lg" withParser>
      {content}
    </Content>
    {showButton && (
      <Button
        id="recommender-error-button"
        isElevated
        onClick={onButtonClick}
        theme="primary"
      >
        {buttonText}
      </Button>
    )}
  </div>
);

AvailabilityError.propTypes = {
  buttonText: PropTypes.string,
  content: PropTypes.string,
  heading: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  showButton: PropTypes.bool,
};

export default AvailabilityError;
